import React from "react";
import useHasSubscription from "../hooks/useHasSubscription";
import SUBSCRIPTION_RULES from "../consts/SUBSCRIPTION_RULES";

const env = {
  vendorUuid: "a9ee763f-e6db-43cb-81a4-26e4bd0a573e",
  resetPasswordRedirectUri: "https://leanwithlilly.com/reset-password/?code=",
};

export const PHYSIO_COURSE_PRODUCT_ID = 3219;
export const LEARN_EXERCISES_COURSE_PRODUCT_ID = 3220; // also so known as the paid how-to's
export const NUTRITION_COURSE_PRODUCT_ID = 3221;
export const FREE_BANDS_EDUCATION_COURSE_PRODUCT_ID = 3222;
export const CHALLENGES_PRODUCT_ID = 9015;

const GUIDE_MAP = {
  3: {
    booty: 3095,
    sabri: 3389,
    hourglass: 3232,
    smallerWaistGuide: 3100,
    janGuide: 4151,
    strongGuide: 4189,
    janWeek3: 4204,
    week4: 4237,
    week5: 4260,
    week6: 4267,
    leanAndStrongTransformationVol14Weeks: 4531,
    galentine: 4273,
    turnItUp: 4280,
    transformationV2: 4307,
    transformationV2_week2: 4313,
    transformationV2Week3: 4324,
    transformationV2Week4: 4358,
    transformationV2Week5: 4367,
    transformationV2Week6: 4420,
    leanAndStrongTransformationVol24Weeks: 4536,
    // maryBraunWeek1: 4457,
    // maryBraunWeek2: 4474,
    deloadPilatesBootCamp: 4437,
    preSummerBootcamp: 4469,
    // maryBraunWeek3: 4525,
    // maryBraunWeek4: 4530,
    feelGoodSummerWeek1: 4550,
    feelGoodSummerWeek2: 4560,
    feelGoodSummerWeek3: 4575,
    periodFriendly: 4570,
    feelGoodSummerWeek4: 4593,
    feelGoodSummerWeek5: 4601,
    feelGoodSummerWeek6: 4614,
    feelGoodSummer4Weeks: 4681,
    bestOfSculpt: 4652,
    bestOfShred: 4658,
    birthday:4695,
    vacay: 4700,
    vacayWeek2: 4730,
    vacayGuide4Weeks: 4842,
    glowWeek1:4743,
    glowWeek2:4757,
    glowWeek3:4785,
    glowWeek4:4790,
    greensAndGlow4Weeks: 4884,
    twentyOneVol2Week1: 4815,
    twentyOneVol2Week2: 4871,
    twentyOneVol2Week3: 4903,
    twentyOneVol24Weeks: 4995,
    gimmeGummyMore: 4924,
    septChallengeWeek1:4934,
    septChallengeWeek2:4943,
    feelGoodFitFactoryWeek3: 5031,
    feelGoodFitFactoryWeek4: 5062,
    feelGoodFitFactoryWeek5: 5084,
    feelGoodFitFactoryWeek6: 5098,
    feelGoodFitFactory4Weeks: 5141,
    halloLeanPrep: 5122,
    halloLeanHellWeek22: 5131,
    bestOfStrength:5156,
    pilatesBody: 5191,
    busyGirlBlackFridayWeek1: 5229,
    busyGirlBlackFridayWeek2: 5246,
    busyGirlBlackFriday4Weeks: 5337,
    cardioGlowUp: 5276,
    cardioGlowUp4Weeks: 5351,
    leanAndPowerful: 5285,
    leanMass2022: 5305,
    leanMass2022Week2: 5332,
    leanMass2022Repacked: 5478,
    bestOfSculptMonth: 5358,
    leanTransformationMethodPhase1: 5517,
    leanTransformationMethodPhase2: 5612,
    leanTransformationMethodWeek1: 5359,
    leanTransformationMethodWeek2: 5461,
    leanTransformationMethodWeek3: 5466,
    leanTransformationMethodWeek4: 5471,
    leanTransformationMethodWeek5: 5539,
    leanTransformationMethodWeek6: 5544,
    leanTransformationMethodWeek7: 5549,
    leanTransformationMethodWeek8: 5554,
    recoverAndStrengthenPilates: 5633,
    winterGlowUp: 5690,
    lowerBody: 5698,
    upperBodyAndAbsShred: 5717,
    sculptBurnAndShape: 5743,
    ohhiit:5770,
    hourglassSculptAndStrengthen: 5788,
    ultimateWeekOfBattles: 5807,
    powerPilates: 5823,
    leanSummerMethodPhase1: 5889,
    leanSummerMethodPhase2: 5981,
    leanSummerMethodWeek1: 5831,
    leanSummerMethodWeek2: 5850,
    leanSummerMethodWeek3: 5901,
    leanSummerMethodWeek4: 5906,
    leanSummerMethodWeek5: 5934,
    leanSummerMethodWeek6: 5939,
    leanSummerMethodWeek7: 5944,
    leanSummerMethodWeek8: 5949,
    leanSecondBirthdayBash: 6052,
    twentyOneVol3: 6161,
    twentyOneVol3Week1: 6099,
    twentyOneVol3Week2: 6136,
    twentyOneVol3Week3: 6150,
    fatBurnCoreGalore: 6181,
    legsSculptAndFatBurn: 6277,
    yourStrongestSelf: 6296,
    shapeBurnPilates: 6305,
    shredWithWeights: 6337,
    hourGlassShredShape: 6354,
    absAndUpperBody: 6363,
    leanEmpoweredMethodPhase1: 6380,
    leanEmpoweredMethodPhase1Week1: 6446,
    leanEmpoweredMethodWeek3: 6474,
    leanEmpoweredMethodPhase1Week2: 6469,
    leanEmpoweredMethodPhase1Week4: 6479,
    leanEmpoweredMethodPhase2Week5: 6580,
    leanEmpoweredMethodPhase2: 6617,
    leanEmpoweredMethodPhase2Week6: 6592,
    leanEmpoweredMethodPhase2Week7: 6604,
    halloleanHellWeek: 6627,
    leanEmpoweredMethodPhase2Week8: 6612,
    pilatesBootcampChallengeWeek1: 6743,
    pilatesBootcampChallengeWeek2: 6748,
    pilatesBootcampChallenge: 6808,
    twentyFiveDaysOfLEANMass: 6835,
    twentyFiveDaysOfLEANMassWeek1: 6763,
    twentyFiveDaysOfLEANMassWeek2: 6782,
    twentyFiveDaysOfLEANMassWeek3: 6787,
    twentyFiveDaysOfLEANMassWeek4: 6792,
    setYourNewYearGoals: 6882,
    newYearPrep: 6887,
    pilatesEvolutionPhase1: 7124,
    pilatesEvolutionWeek1: 6924,
    pilatesEvolutionWeek2: 7029,
    pilatesEvolutionWeek3: 7129,
    pilatesEvolutionWeek4: 7151,
    pilatesEvolutionPhase2: 7213,
    pilatesEvolutionWeek5: 7172,
    pilatesEvolutionWeek6: 7189,
    pilatesEvolutionWeek7: 7194,
    pilatesEvolutionDay50: 7202,
    pilatesEvolutionWeek9: 7207,
    bestOfLmpe: 7278,
    bestOfLmpeWeek1: 7241,
    bestOfLmpeWeek2: 7246,
    weekOfWellness: 7272,
    matInspiredReformerPilates: 7292,
    ultimateStrengthChallenge: 7304,
    pilatesStrengthFusion: 7345,
    lowImpactFatBurn: 7431,
    sunsOutBunsOut: 7441,
    powerUpPilatesWeek1: 7446,
    powerUpPilatesWeek2: 7475,
    powerUpPilatesWeek3: 7519,
    summerSurprisePrep: 7538,
    summerSurprisePrepw1: 7496,
    summerSurprisePrepw2: 7501,
    pilatesSummerSculptPhase1: 7554,
    pilatesSummerSculptWeek1: 7532,
    pilatesSummerSculptWeek2: 7570,
    pilatesSummerSculptWeek3: 7602,
    pilatesSummerSculptWeek4: 7635,
    pilatesSummerSculptPhase2: 7649,
    pilatesSummerSculptWeek5: 7641,
    pilatesSummerSculptWeek6: 7672,
    pilatesSummerSculptWeek7: 7690,
    pilatesSummerSculptWeek8: 7683,
    pilatesSummerSculptWeek9: 7731,
    leanLifestyle: 7740,
    coreStrengthStability: 7770,
    buildStrengthMonthWeek1: 7793,
    buildStrengthMonthWeek2: 7847,
    buildStrengthMonthWeek3: 7852,
    buildStrengthMonthWeek4: 7872,
    resetAndThriveChallenge: 7894,
    buildYourStengthMonth: 7923,
    bestOfLeanMethod: 7911,
    bestOfLeanMethodWeek1: 7916,
    bestOfLeanMethodWeek2: 7937,
    bestOfLeanMethodWeek3: 7942,
    bestOfLeanMethodWeek4: 7947,
    ultimateStrengthChallenge2: 8002,
    halloLeanHellWeek24: 8015,
    twentyOneVol4Week1: 8040,
    twentyOneVol4Week2: 8062,
    twentyOneVol4Week3: 8070,
    twentyOneVol4: 8102,
    bestOfSculptWeek1: 8039,
    bestOfSculptWeek2: 8110,
    bestOfSculptWeek3: 8124,
    bestOfSculptWeek4: 8178,
    bestOfSculptStrength: 8189,
    winterGlowUp2: 8205,
    newYearGoals: 8231,
    levelUpPrep: 8281,
    leanMethodLevelUp: 8299,
    leanMethodLevelUpW1: 8317,
    leanMethodLevelUpW2: 8352,
    leanMethodLevelUpW3: 8357,
    leanMethodLevelUpW4: 8366,
    leanMethodLevelUpW5: 8377,
    leanMethodLevelUpW6: 8436,
    leanMethodLevelUpW7: 8603,
    leanMethodLevelUpW8: 8609,
    leanMethodLevelUpW9: 8632,
    leanMethodDeloadWeek: 8655,
    toneAndTransform: 8741,
    coreStrengthStability2: 8746,
    sevenDayBootySculpt: 8791,
    defineAndRefine: 8796,
    sweatyBootcamp: 8908,
    summerPrep2025W1: 8959,
    summerPrep2025: 8954,
    summerPrep2025W2: 8975,
    leanMethodElevateW1: 9001,
    leanMethodElevateP1: 8985,
    leamMethodLevel5: 9018,    
    leanMethodLevel4: 9022,    
    leanMethodLevel3: 9032,    
    leanMethodLevel2: 9027,
    leanMethodElevateW2: 9007,
    leanMethodElevateW3: 9012,
    leanMethodElevateW4: 9084,
    leanMethodElevateW5: 9095,
    leanMethodElevateP2: 8990,
    leanMethodElevateW6: 9142,
    leanMethodElevateW7: 9175,
    leanMethodElevateW8: 9182,
    leanMethodElevateW9: 9187,
    pilatesLowImpactWeek: 9201,
    scultLeanMuscle: 9208,
    buildStrengthPilates: 9213,
    leanAbsAndUpperBody: 9264,
    weightsAndBurn: 9269,
    resetChallenge: 9341,
    resetChallengeWeek1: 9324,
    resetChallengeWeek2: 9329,
    resetChallengeWeek3: 9334,
    powerLegsAndSculpt: 9359,
    wellnessReadyWeek: 9379,
    pilatedFusionBurn: 9364,
    leanSculptAndFlow: 9421,
    strengthAndBalance: 9454,
    transformationPrep: 9533,
    leanMethodTransformation: 9483,
    leanMethodTransformationW1: 9478,
    leanMethodTransformationW2: 9514,
    leanMethodTransformationW3: 9519,
    leanMethodTransformationW4: 9524,
    hourglassSculpt: 9589,
    lowerBodyStrengthSculpt: 9637,
    reformerInspiredPilates: 9653,
    coreCardioStength: 9662,
    defineChallengePhase: 9688,
    defineChallengeWeek1: 9668,
    defineChallengeWeek2: 9673,
    defineChallengeWeek3: 9678,
    defineChallengeWeek4: 9683,
    defineChallengePhase2: 9841,
    defineChallengeWeek5: 9849,
    leanDefineChallengeWeek6: 9854,
    leanDefineChallengeWeek7: 9855,
    leanDefineChallengeWeek8: 9864,
    lean2in1PrepWeek: 9910,
    lean2In1MethodPilatesXStrengthWeek1: 9923,
    lean2In1MethodPilatesXStrengthFullGuide: 9914,
    lean2In1MethodPilatesXStrengthWeek2: 9928,
    lean2In1MethodPilatesXStrengthWeek3: 9933,
    lean7DayBootySculpt2026: 9978,
    leanCoreStrengthAndStability: 10000,
    leanUltimateStrengthWeek: 10019,
    leanAbsAndUpperBody2026: 10027,
    leanSummerSculptChallengePrepWeek: 10049,
    leanSummerSculptChallengeFullGuide: 10054,
    leanSummerSculptChallengeWeek1: 10059,
    leanSummerSculptChallengeWeek2: 10082,
    leanSummerSculptChallengeWeek3: 10086,
    leanSummerSculptChallengeWeek4: 10143,
    leanSummerSculptChallengeWeek5: 10148,
    leanSummerSculptChallengeWeek6: 10153,
    leanLowerBodyStrengthandCardioWeek: 10190,
    lean2In1AbsAndSculptFullGuide: 10211,
    lean2In1AbsAndSculptWeek1: 10215,
    lean2in1AbsAndSculptFullLengthGuide: 10211,
    lean2In1AbsAndSculptWeekOne: 10219,
    lean2In1AbsAndSculptWeek2: 10223,
    lean2In1AbsandSculptWeek3: 10253,
    leanSummerSeriesArms: 10273,
    leanSummerSeriesLowerBody: 10290,
    leanSummerSeriesQuickBurn: 10295,
    leanSummerSeriesAbs: 10300,
    leanSummerSeriesGlutes2: 10315,
    summerSeriesUpperBody: 10320,
    leanChallengePrepWeekGuide: 10358,
    reDefineBeginner: 10373,
    redefineIntermediateandAdvanced: 10353,
    redefineIntermediateandAdvancedFullLength: 10369,
    redefineIntermediateWeek2: 10384,
    redefineWeek3: 10389,
    redefineWeek4: 10402,
  },
  4: {
    booty: 3094,
    sabri: 3388,
    hourglass: 3233,
    smallerWaistGuide: 3099,
    twentyOne: 3472,
    cutGuide: 3670,
    strongCapable: 4100,
    janGuide: 4150,
    strongGuide: 4188,
    janWeek3: 4203,
    week4: 4236,
    week5: 4259,
    week6: 4266,
    leanAndStrongTransformationVol14Weeks: 4532,
    galentine: 4272,
    turnItUp: 4279,
    transformationV2: 4306,
    transformationV2_week2: 4312,
    transformationV2Week3: 4323,
    transformationV2Week4: 4357,
    transformationV2Week5: 4366,
    transformationV2Week6: 4419,
    leanAndStrongTransformationVol24Weeks: 4537,
    // maryBraunWeek1: 4456,
    // maryBraunWeek2: 4473,
    deloadPilatesBootCamp: 4438,
    preSummerBootcamp: 4468,
    // maryBraunWeek3: 4524,
    // maryBraunWeek4: 4529,
    feelGoodSummerWeek1: 4549,
    feelGoodSummerWeek2: 4559,
    feelGoodSummerWeek3: 4574,
    periodFriendly: 4570,
    feelGoodSummerWeek4:4592,
    feelGoodSummerWeek5:4602,
    feelGoodSummerWeek6:4613,
    feelGoodSummer4Weeks: 4680,
    bestOfSculpt: 4651,
    bestOfShred: 4659,
    birthday:4696,
    vacay: 4701,
    vacayWeek2: 4729,
    vacayGuide4Weeks: 4843,
    glowWeek1:4744,
    glowWeek2:4756,
    glowWeek3:4786,
    glowWeek4:4791,
    greensAndGlow4Weeks: 4883,
    twentyOneVol2Week1: 4814,
    twentyOneVol2Week2: 4870,
    twentyOneVol2Week3: 4902,
    twentyOneVol24Weeks: 4994,
    gimmeGummyMore: 4923,
    septChallengeWeek1:4933,
    septChallengeWeek2:4942,
    feelGoodFitFactoryWeek3: 5030,
    feelGoodFitFactoryWeek4: 5061,
    feelGoodFitFactoryWeek5: 5083,
    feelGoodFitFactoryWeek6: 5097,
    feelGoodFitFactory4Weeks: 5140,
    halloLeanPrep: 5123,
    halloLeanHellWeek22: 5132,
    bestOfStrength: 5157,
    pilatesBody: 5192,
    busyGirlBlackFridayWeek1: 5230,
    busyGirlBlackFridayWeek2: 5247,
    busyGirlBlackFriday4Weeks: 5338,
    cardioGlowUp: 5277,
    cardioGlowUp4Weeks: 5350,
    leanAndPowerful: 5286,
    leanMass2022: 5306,
    leanMass2022Week2: 5333,
    leanMass2022Repacked: 5477,
    bestOfSculptMonth: 5357,
    leanTransformationMethodPhase1: 5516,
    leanTransformationMethodPhase2: 5611,
    leanTransformationMethodWeek1: 5360,
    leanTransformationMethodWeek2: 5460,
    leanTransformationMethodWeek3: 5465,
    leanTransformationMethodWeek4: 5470,
    leanTransformationMethodWeek5: 5538 ,
    leanTransformationMethodWeek6: 5543,
    leanTransformationMethodWeek7: 5548,
    leanTransformationMethodWeek8: 5553,
    recoverAndStrengthenPilates: 5632,
    winterGlowUp: 5689,
    lowerBody: 5697,
    upperBodyAndAbsShred: 5716,
    sculptBurnAndShape: 5742,
    ohhiit:5769,
    hourglassSculptAndStrengthen: 5787,
    ultimateWeekOfBattles: 5808,
    powerPilates: 5822,
    leanSummerMethodPhase1: 5888,
    leanSummerMethodPhase2: 5982,
    leanSummerMethodWeek1: 5832,
    leanSummerMethodWeek2: 5851,
    leanSummerMethodWeek3: 5900,
    leanSummerMethodWeek4: 5905,
    leanSummerMethodWeek5: 5933,
    leanSummerMethodWeek6: 5938,
    leanSummerMethodWeek7: 5943,
    leanSummerMethodWeek8: 5948,
    leanSecondBirthdayBash: 6051,
    twentyOneVol3: 6160,
    twentyOneVol3Week1: 6100,
    twentyOneVol3Week2: 6137,
    twentyOneVol3Week3: 6149,
    fatBurnCoreGalore: 6180,
    legsSculptAndFatBurn: 6276,
    yourStrongestSelf: 6295,
    shapeBurnPilates: 6304,
    shredWithWeights: 6338,
    hourGlassShredShape: 6355,
    absAndUpperBody: 6364,
    leanEmpoweredMethodPhase1: 6379,
    leanEmpoweredMethodPhase1Week1: 6451,
    leanEmpoweredMethodWeek3: 6475,
    leanEmpoweredMethodPhase1Week2: 6470,
    leanEmpoweredMethodPhase1Week4: 6480,
    leanEmpoweredMethodPhase2Week5: 6581,
    leanEmpoweredMethodPhase2: 6616,
    leanEmpoweredMethodPhase2Week6: 6591,
    leanEmpoweredMethodPhase2Week7: 6603,
    halloLeanHellWeek: 6626,
    leanEmpoweredMethodPhase2Week8: 6611,
    pilatesBootcampChallengeWeek1: 6742,
    pilatesBootcampChallengeWeek2: 6747,
    pilatesBootcampChallenge: 6807,
    twentyFiveDaysOfLEANMass: 6834,
    twentyFiveDaysOfLEANMassWeek1: 6764,
    twentyFiveDaysOfLEANMassWeek2: 6783,
    twentyFiveDaysOfLEANMassWeek3: 6788,
    twentyFiveDaysOfLEANMassWeek4: 6793,
    setYourNewYearGoals: 6881,
    newYearPrep: 6886,
    pilatesEvolutionPhase1: 7123,
    pilatesEvolutionWeek1: 6923,
    pilatesEvolutionWeek2: 7028,
    pilatesEvolutionWeek3: 7128,
    pilatesEvolutionWeek4: 7150,
    pilatesEvolutionPhase2: 7212,
    pilatesEvolutionWeek5: 7171,
    pilatesEvolutionWeek6: 7188,
    pilatesEvolutionWeek7: 7193,
    pilatesEvolutionDay50: 7201,
    pilatesEvolutionWeek9: 7206,
    bestOfLmpe: 7277,
    bestOfLmpeWeek1: 7240,
    bestOfLmpeWeek2: 7245,
    weekOfWellness: 7271,
    matInspiredReformerPilates: 7291,
    ultimateStrengthChallenge: 7303,
    pilatesStrengthFusion: 7346,
    lowImpactFatBurn: 7430,
    sunsOutBunsOut: 7440,
    powerUpPilatesWeek1: 7445,
    powerUpPilatesWeek2: 7474,
    powerUpPilatesWeek3: 7518,
    summerSurprisePrep: 7537,
    summerSurprisePrepw1: 7495,
    summerSurprisePrepw2: 7500,
    pilatesSummerSculptPhase1: 7553,
    pilatesSummerSculptWeek1: 7531,
    pilatesSummerSculptWeek2: 7569,
    pilatesSummerSculptWeek3: 7601,
    pilatesSummerSculptWeek4: 7634,
    pilatesSummerSculptPhase2: 7648,
    pilatesSummerSculptWeek5: 7640,
    pilatesSummerSculptWeek6: 7671,
    pilatesSummerSculptWeek7: 7689,
    pilatesSummerSculptWeek8: 7682,
    pilatesSummerSculptWeek9: 7730,
    leanLifestyle: 7739,
    coreStrengthStability: 7769,
    buildStrengthMonthWeek1: 7792,
    buildStrengthMonthWeek2: 7846,
    buildStrengthMonthWeek3: 7851,
    buildStrengthMonthWeek4: 7873,
    resetAndThriveChallenge: 7895,
    buildYourStengthMonth: 7922,
    bestOfLeanMethod: 7910,
    bestOfLeanMethodWeek1: 7915,
    bestOfLeanMethodWeek2: 7936,
    bestOfLeanMethodWeek3: 7941,
    bestOfLeanMethodWeek4: 7946,
    ultimateStrengthChallenge2: 8001,
    halloLeanHellWeek24: 8016,
    twentyOneVol4Week1: 8041,
    twentyOneVol4Week2: 8063,
    twentyOneVol4Week3: 8071,
    twentyOneVol4: 8095,
    bestOfSculptWeek1: 8038,
    bestOfSculptWeek2: 8111,
    bestOfSculptWeek3: 8123,
    bestOfSculptWeek4: 8177,
    bestOfSculptStrength: 8190,
    winterGlowUp2: 8206,
    newYearGoals: 8230,
    levelUpPrep: 8280,
    leanMethodLevelUp: 8298,
    leanMethodLevelUpW1: 8316,
    leanMethodLevelUpW2: 8351,
    leanMethodLevelUpW3: 8356,
    leanMethodLevelUpW4: 8367,
    leanMethodLevelUpW5: 8376,
    leanMethodLevelUpW6: 8435,
    leanMethodLevelUpW7: 8602,
    leanMethodLevelUpW8: 8608,
    leanMethodLevelUpW9: 8631,
    leanMethodDeloadWeek: 8654,
    toneAndTransform: 8742,
    coreStrengthStability2: 8747,
    sevenDayBootySculpt: 8790,
    defineAndRefine: 8795,
    sweatyBootcamp: 8907,
    summerPrep2025W1: 8958,
    summerPrep2025: 8952,
    summerPrep2025W2: 8974,
    leanMethodElevateW1: 9000,
    leanMethodElevateP1: 8984,    
    leamMethodLevel5: 9017,    
    leanMethodLevel4: 9021,    
    leanMethodLevel3: 9031,    
    leanMethodLevel2: 9026,
    leanMethodElevateW2: 9006,
    leanMethodElevateW3: 9011,
    leanMethodElevateW4: 9083,
    leanMethodElevateW5: 9094,
    leanMethodElevateP2: 8989,
    leanMethodElevateW6: 9141,
    leanMethodElevateW7: 9174,
    leanMethodElevateW8: 9181,
    leanMethodElevateW9: 9186,
    pilatesLowImpactWeek: 9200,
    scultLeanMuscle: 9207,
    buildStrengthPilates: 9212,
    leanAbsAndUpperBody: 9263,
    weightsAndBurn: 9268,
    resetChallenge: 9340,
    resetChallengeWeek1: 9323,
    resetChallengeWeek2: 9328,
    resetChallengeWeek3: 9333,
    powerLegsAndSculpt: 9358,
    wellnessReadyWeek: 9378,
    pilatedFusionBurn: 9363,
    leanSculptAndFlow: 9420,
    strengthAndBalance: 9453,
    transformationPrep: 9532,
    leanMethodTransformation: 9482,
    leanMethodTransformationW1: 9477,
    leanMethodTransformationW2: 9513,
    leanMethodTransformationW3: 9518,
    leanMethodTransformationW4: 9523,
    hourglassSculpt: 9588,
    lowerBodyStrengthSculpt: 9636,
    reformerInspiredPilates: 9652,
    coreCardioStength: 9661,
    defineChallengePhase: 9687,
    defineChallengeWeek1: 9667,
    defineChallengeWeek2: 9672,
    defineChallengeWeek3: 9677,
    defineChallengeWeek4: 9682,
    defineChallengePhase2: 9840,
    defineChallengeWeek5: 9848,
    leanDefineChallengeWeek6: 9853,
    leanDefineChallengeWeek7: 9856,
    leanDefineChallengeWeek8: 9863,
    lean2in1PrepWeek: 9909,
    lean2In1MethodPilatesXStrengthWeek1: 9922,
    lean2In1MethodPilatesXStrengthFullGuide: 9913,
    lean2In1MethodPilatesXStrengthWeek2: 9927,
    lean2In1MethodPilatesXStrengthWeek3: 9932,
    lean7DayBootySculpt2026: 9977,
    leanCoreStrengthAndStability: 9999,
    leanUltimateStrengthWeek: 10018,
    leanAbsAndUpperBody2026: 10026,
    leanSummerSculptChallengePrepWeek: 10048,
    leanSummerSculptChallengeFullGuide: 10053,
    leanSummerSculptChallengeWeek1: 10058,
    leanSummerSculptChallengeWeek2: 10081,
    leanSummerSculptChallengeWeek3: 10085,
    leanSummerSculptChallengeWeek4: 10142,
    leanSummerSculptChallengeWeek5: 10147,
    leanSummerSculptChallengeWeek6: 10152,
    leanLowerBodyStrengthandCardioWeek: 10189,
    lean2In1AbsAndSculptFullGuide: 10210,
    lean2In1AbsAndSculptWeek1: 10214,
    lean2in1AbsAndSculptFullLengthGuide: 10210,
    lean2In1AbsAndSculptWeekOne: 10218,
    lean2In1AbsAndSculptWeek2: 10222,
    lean2In1AbsandSculptWeek3: 10252,
    leanSummerSeriesArms: 10272,
    leanSummerSeriesLowerBody: 10289,
    leanSummerSeriesQuickBurn: 10294,
    leanSummerSeriesAbs: 10299,
    leanSummerSeriesGlutes2: 10314,
    summerSeriesUpperBody: 10319,
    leanChallengePrepWeekGuide: 10357,
    reDefineBeginner: 10372,
    redefineIntermediateandAdvanced: 10352,
    redefineIntermediateandAdvancedFullLength: 10368,
    redefineIntermediateWeek2: 10383,
    redefineWeek3: 10388,
    redefineWeek4: 10401,
  },
  5: {
    booty: 3093,
    sabri: 3387,
    hourglass: 3234,
    smallerWaistGuide: 3098,
    twentyOne: 3471,
    cutGuide: 3669,
    strongCapable: 4099,
    janGuide: 4149,
    strongGuide: 4151,
    janWeek3: 4202,
    week4: 4235,
    week5: 4258,
    week6: 4265,
    leanAndStrongTransformationVol14Weeks: 4533,
    galentine: 4271,
    turnItUp: 4278,
    transformationV2: 4305,
    transformationV2_week2: 4311,
    transformationV2Week3: 4322,
    transformationV2Week4: 4356,
    transformationV2Week5: 4365,
    transformationV2Week6: 4418,
    leanAndStrongTransformationVol24Weeks: 4538,
    // maryBraunWeek1: 4455,
    // maryBraunWeek2: 4472,
    deloadPilatesBootCamp: 4442,
    preSummerBootcamp: 4467,
    // maryBraunWeek3: 4523,
    // maryBraunWeek4: 4528,
    feelGoodSummerWeek1: 4548,
    feelGoodSummerWeek2: 4558,
    feelGoodSummerWeek3: 4573,
    periodFriendly: 4570,
    feelGoodSummerWeek4: 4591,
    feelGoodSummerWeek5:4600,
    feelGoodSummerWeek6:4612,
    feelGoodSummer4Weeks: 4679,
    bestOfSculpt: 4650,
    bestOfShred: 4660,
    birthday:4697,
    vacay: 4702,
    vacayWeek2: 4728,
    vacayGuide4Weeks: 4844,
    glowWeek1:4745,
    glowWeek2:4755,
    glowWeek3:4787,
    glowWeek4:4792,
    greensAndGlow4Weeks: 4882,
    twentyOneVol2Week1: 4813,
    twentyOneVol2Week2: 4869,
    twentyOneVol2Week3: 4901,
    twentyOneVol24Weeks: 4993,
    gimmeGummyMore: 4922,
    septChallengeWeek1:4932,
    septChallengeWeek2:4941,
    feelGoodFitFactoryWeek3: 5029,
    feelGoodFitFactoryWeek4: 5060,
    feelGoodFitFactoryWeek5: 5082,
    feelGoodFitFactoryWeek6: 5096,
    feelGoodFitFactory4Weeks: 5139,
    halloLeanPrep: 5124,
    halloLeanHellWeek22: 5133,
    bestOfStrength: 5158,
    pilatesBody: 5193,
    busyGirlBlackFridayWeek1: 5231,
    busyGirlBlackFridayWeek2: 5248,
    busyGirlBlackFriday4Weeks: 5339,
    cardioGlowUp: 5278,
    cardioGlowUp4Weeks: 5349,
    leanAndPowerful: 5287,
    leanMass2022: 5307,
    leanMass2022Week2: 5334,
    leanMass2022Repacked: 5476,
    bestOfSculptMonth: 5356,
    leanTransformationMethodPhase1: 5515,
    leanTransformationMethodPhase2: 5610,
    leanTransformationMethodWeek1: 5361,
    leanTransformationMethodWeek2: 5459,
    leanTransformationMethodWeek3: 5464,
    leanTransformationMethodWeek4: 5469,
    leanTransformationMethodWeek5: 5537,
    leanTransformationMethodWeek6: 5542,
    leanTransformationMethodWeek7: 5547,
    leanTransformationMethodWeek8: 5552,
    recoverAndStrengthenPilates: 5631,
    winterGlowUp: 5688,
    lowerBody: 5696,
    upperBodyAndAbsShred: 5715,
    sculptBurnAndShape: 5741,
    ohhiit:5768,
    hourglassSculptAndStrengthen: 5786,
    ultimateWeekOfBattles: 5809,
    powerPilates: 5821,
    leanSummerMethodPhase1: 5887,
    leanSummerMethodPhase2: 5983,
    leanSummerMethodWeek1: 5833,
    leanSummerMethodWeek2: 5852,
    leanSummerMethodWeek3: 5899,
    leanSummerMethodWeek4: 5904,
    leanSummerMethodWeek5: 5932,
    leanSummerMethodWeek6: 5937,
    leanSummerMethodWeek7: 5942,
    leanSummerMethodWeek8: 5947,
    leanSecondBirthdayBash: 6050,
    twentyOneVol3: 6159,
    twentyOneVol3Week1: 6101,
    twentyOneVol3Week2: 6138,
    twentyOneVol3Week3: 6148,
    fatBurnCoreGalore: 6179,
    legsSculptAndFatBurn: 6275,
    yourStrongestSelf: 6294,
    shapeBurnPilates: 6303,
    shredWithWeights: 6339,
    hourGlassShredShape: 6356,
    absAndUpperBody: 6365,
    leanEmpoweredMethodPhase1: 6378,
    leanEmpoweredMethodPhase1Week1: 6452,
    leanEmpoweredMethodWeek3: 6476,
    leanEmpoweredMethodPhase1Week2: 6471,
    leanEmpoweredMethodPhase1Week4: 6481,
    leanEmpoweredMethodPhase2Week5: 6582,
    leanEmpoweredMethodPhase2: 6615,
    leanEmpoweredMethodPhase2Week6: 6590,
    leanEmpoweredMethodPhase2Week7: 6602,
    halloLeanHellWeek: 6625,
    leanEmpoweredMethodPhase2Week8: 6610,
    pilatesBootcampChallengeWeek1: 6741,
    pilatesBootcampChallengeWeek2: 6746,
    pilatesBootcampChallenge: 6806,
    twentyFiveDaysOfLEANMass: 6833,
    twentyFiveDaysOfLEANMassWeek1: 6765,
    twentyFiveDaysOfLEANMassWeek2: 6784,
    twentyFiveDaysOfLEANMassWeek3: 6789,
    twentyFiveDaysOfLEANMassWeek4: 6794,
    setYourNewYearGoals: 6880,
    newYearPrep: 6885,
    pilatesEvolutionPhase1: 7122,
    pilatesEvolutionWeek1: 6922,
    pilatesEvolutionWeek2: 7027,
    pilatesEvolutionWeek3: 7127,
    pilatesEvolutionWeek4: 7149,
    pilatesEvolutionPhase2: 7211,
    pilatesEvolutionWeek5: 7170,
    pilatesEvolutionWeek6: 7187,
    pilatesEvolutionWeek7: 7192,
    pilatesEvolutionDay50: 7200,
    pilatesEvolutionWeek9: 7205,
    bestOfLmpe: 7276,
    bestOfLmpeWeek1: 7239,
    bestOfLmpeWeek2: 7244,
    weekOfWellness: 7270,
    matInspiredReformerPilates: 7290,
    ultimateStrengthChallenge: 7302,
    pilatesStrengthFusion: 7347,
    lowImpactFatBurn: 7429,
    sunsOutBunsOut: 7439,
    powerUpPilatesWeek1: 7444,
    powerUpPilatesWeek2: 7473,
    powerUpPilatesWeek3: 7517,
    summerSurprisePrep: 7536,
    summerSurprisePrepw1: 7494,
    summerSurprisePrepw2: 7499,
    pilatesSummerSculptPhase1: 7552,
    pilatesSummerSculptWeek1: 7530,
    pilatesSummerSculptWeek2: 7568,
    pilatesSummerSculptWeek3: 7600,
    pilatesSummerSculptWeek4: 7633,
    pilatesSummerSculptPhase2: 7647,
    pilatesSummerSculptWeek5: 7639,
    pilatesSummerSculptWeek6: 7670,
    pilatesSummerSculptWeek7: 7688,
    pilatesSummerSculptWeek8: 7681,
    pilatesSummerSculptWeek9: 7729,
    leanLifestyle: 7738,
    coreStrengthStability: 7768,
    buildStrengthMonthWeek1: 7791,
    buildStrengthMonthWeek2: 7845,
    buildStrengthMonthWeek3: 7850,
    buildStrengthMonthWeek4: 7874,
    resetAndThriveChallenge: 7896,
    buildYourStengthMonth: 7921,
    bestOfLeanMethod: 7909,
    bestOfLeanMethodWeek1: 7914,
    bestOfLeanMethodWeek2: 7935,
    bestOfLeanMethodWeek3: 7940,
    bestOfLeanMethodWeek4: 7945,
    ultimateStrengthChallenge2: 8000,
    halloLeanHellWeek24: 8017,
    twentyOneVol4Week1: 8042,
    twentyOneVol4Week2: 8068,
    twentyOneVol4Week3: 8072,
    twentyOneVol4: 8101,
    bestOfSculptWeek1: 8037,
    bestOfSculptWeek2: 8112,
    bestOfSculptWeek3: 8122,
    bestOfSculptWeek4: 8176,
    bestOfSculptStrength: 8191,
    winterGlowUp2: 8207,
    newYearGoals: 8229,
    levelUpPrep: 8279,
    leanMethodLevelUp: 8297,
    leanMethodLevelUpW1: 8315,
    leanMethodLevelUpW2: 8350,
    leanMethodLevelUpW3: 8355,
    leanMethodLevelUpW4: 8368,
    leanMethodLevelUpW5: 8375,
    leanMethodLevelUpW6: 8434,
    leanMethodLevelUpW7: 8601,
    leanMethodLevelUpW8: 8607,
    leanMethodLevelUpW9: 8630,
    leanMethodDeloadWeek: 8653,
    toneAndTransform: 8743,
    coreStrengthStability2: 8748,
    sevenDayBootySculpt: 8789,
    defineAndRefine: 8794,
    sweatyBootcamp: 8906,
    summerPrep2025W1: 8957,
    summerPrep2025: 8951,
    summerPrep2025W2: 8973,
    leanMethodElevateW1: 8999,
    leanMethodElevateP1: 8983,    
    leamMethodLevel5: 9016,    
    leanMethodLevel4: 9020,    
    leanMethodLevel3: 9030,    
    leanMethodLevel2: 9025,
    leanMethodElevateW2: 9005,
    leanMethodElevateW3: 9010,
    leanMethodElevateW4: 9081,
    leanMethodElevateW5: 9093,
    leanMethodElevateP2: 8988,
    leanMethodElevateW6: 9140,
    leanMethodElevateW7: 9173,
    leanMethodElevateW8: 9180,
    leanMethodElevateW9: 9185,
    pilatesLowImpactWeek: 9199,
    scultLeanMuscle: 9205,
    buildStrengthPilates: 9211,
    leanAbsAndUpperBody: 9262,
    weightsAndBurn: 9267,
    resetChallenge: 9339,
    resetChallengeWeek1: 9322,
    resetChallengeWeek2: 9327,
    resetChallengeWeek3: 9332,
    powerLegsAndSculpt: 9357,
    wellnessReadyWeek: 9377,
    pilatedFusionBurn: 9362,
    leanSculptAndFlow: 9419,
    strengthAndBalance: 9452,
    transformationPrep: 9531,
    leanMethodTransformation: 9481,
    leanMethodTransformationW1: 9476,
    leanMethodTransformationW2: 9512,
    leanMethodTransformationW3: 9517,
    leanMethodTransformationW4: 9522,
    hourglassSculpt: 9587,
    lowerBodyStrengthSculpt: 9635,
    reformerInspiredPilates: 9651,
    coreCardioStength: 9660,
    defineChallengePhase: 9686,
    defineChallengeWeek1: 9666,
    defineChallengeWeek2: 9671,
    defineChallengeWeek3: 9676,
    defineChallengeWeek4: 9681,
    defineChallengePhase2: 9839,
    defineChallengeWeek5: 9847,
    leanDefineChallengeWeek6: 9852,
    leanDefineChallengeWeek7: 9857,
    leanDefineChallengeWeek8: 9862,
    lean2in1PrepWeek: 9908,
    lean2In1MethodPilatesXStrengthWeek1: 9921,
    lean2In1MethodPilatesXStrengthFullGuide: 9912,
    lean2In1MethodPilatesXStrengthWeek2: 9926,
    lean2In1MethodPilatesXStrengthWeek3: 9931,
    lean7DayBootySculpt2026: 9976,
    leanCoreStrengthAndStability: 9998,
    leanUltimateStrengthWeek: 10017,
    leanAbsAndUpperBody2026: 10025,
    leanSummerSculptChallengePrepWeek: 10047,
    leanSummerSculptChallengeFullGuide: 10052,
    leanSummerSculptChallengeWeek1: 10057,
    leanSummerSculptChallengeWeek2: 10080,
    leanSummerSculptChallengeWeek3: 10084,
    leanSummerSculptChallengeWeek4: 10141,
    leanSummerSculptChallengeWeek5: 10146,
    leanSummerSculptChallengeWeek6: 10151,
    leanLowerBodyStrengthandCardioWeek: 10188,
    lean2In1AbsAndSculptFullGuide: 10209,
    lean2In1AbsAndSculptWeek1: 10213,
    lean2in1AbsAndSculptFullLengthGuide: 10209,
    lean2In1AbsAndSculptWeekOne: 10217,
    lean2In1AbsAndSculptWeek2: 10221,
    lean2In1AbsandSculptWeek3: 10251,
    leanSummerSeriesArms: 10271,
    leanSummerSeriesLowerBody: 10288,
    leanSummerSeriesQuickBurn: 10293,
    leanSummerSeriesAbs: 10298,
    leanSummerSeriesGlutes2: 10313,
    summerSeriesUpperBody: 10318,
    leanChallengePrepWeekGuide: 10356,
    reDefineBeginner: 10371,
    redefineIntermediateandAdvanced: 10351,
    redefineIntermediateandAdvancedFullLength: 10367,
    redefineIntermediateWeek2: 10382,
    redefineWeek3: 10387,
    redefineWeek4: 10400,
  },
  6: {
    booty: 3092,
    sabri: 3386,
    hourglass: 3235,
    smallerWaistGuide: 3097,
    twentyOne: 3470,
    cutGuide: 3668,
    strongCapable: 4098,
    pilates: 4141,
    janGuide: 4148,
    strongGuide: 4150,
    janWeek3: 4201,
    week4: 4234,
    week5: 4257,
    week6: 4264,
    leanAndStrongTransformationVol14Weeks: 4534,
    galentine: 4270,
    turnItUp: 4277,
    transformationV2: 4304,
    transformationV2_week2: 4310,
    transformationV2Week3: 4321,
    transformationV2Week4: 4355,
    transformationV2Week5: 4364,
    transformationV2Week6: 4417,
    leanAndStrongTransformationVol24Weeks: 4539,
    // maryBraunWeek1: 4454,
    // maryBraunWeek2: 4471,
    deloadPilatesBootCamp: 4443,
    preSummerBootcamp: 4466,
    // maryBraunWeek3: 4522,
    // maryBraunWeek4: 4527,
    feelGoodSummerWeek1: 4547,
    feelGoodSummerWeek2: 4557,
    feelGoodSummerWeek3: 4572,
    periodFriendly: 4570,
    feelGoodSummerWeek4: 4590,
    feelGoodSummerWeek5:4599,
    feelGoodSummerWeek6: 4611,
    feelGoodSummer4Weeks: 4678,
    bestOfSculpt: 4649,
    bestOfShred: 4661,
    birthday:4698,
    vacay: 4703,
    vacayWeek2: 4727,
    vacayGuide4Weeks: 4845,
    glowWeek1:4746,
    glowWeek2:4754,
    glowWeek3:4788,
    glowWeek4:4793,
    greensAndGlow4Weeks: 4881,
    twentyOneVol2Week1: 4812,
    twentyOneVol2Week2: 4868,
    twentyOneVol2Week3: 4900,
    twentyOneVol24Weeks: 4992,
    gimmeGummyMore: 4921,
    septChallengeWeek1:4931,
    septChallengeWeek2:4940,
    feelGoodFitFactoryWeek3: 5028,
    feelGoodFitFactoryWeek4: 5059,
    feelGoodFitFactoryWeek5: 5081,
    feelGoodFitFactoryWeek6: 5095,
    feelGoodFitFactory4Weeks: 5138,
    halloLeanPrep: 5125,
    halloLeanHellWeek22: 5134,
    bestOfStrength: 5159,
    pilatesBody: 5194,
    busyGirlBlackFridayWeek1: 5232,
    busyGirlBlackFridayWeek2: 5249,
    busyGirlBlackFriday4Weeks: 5340,
    cardioGlowUp: 5279,
    cardioGlowUp4Weeks: 5348,
    leanAndPowerful: 5288,
    leanMass2022: 5308,
    leanMass2022Week2: 5335,
    leanMass2022Repacked: 5475,
    bestOfSculptMonth: 5355,
    leanTransformationMethodPhase1: 5514,
    leanTransformationMethodPhase2: 5609,
    leanTransformationMethodWeek1: 5362,
    leanTransformationMethodWeek2: 5458,
    leanTransformationMethodWeek3: 5463,
    leanTransformationMethodWeek4: 5468,
    leanTransformationMethodWeek5: 5536,
    leanTransformationMethodWeek6: 5541,
    leanTransformationMethodWeek7: 5546,
    leanTransformationMethodWeek8: 5551,
    recoverAndStrengthenPilates: 5630,
    winterGlowUp: 5687,
    lowerBody: 5695,
    upperBodyAndAbsShred: 5714,
    sculptBurnAndShape: 5740,
    ohhiit:5767,
    hourglassSculptAndStrengthen: 5785,
    ultimateWeekOfBattles: 5810,
    powerPilates: 5820,
    leanSummerMethodPhase1: 5886,
    leanSummerMethodPhase2: 5984,
    leanSummerMethodWeek1: 5834,
    leanSummerMethodWeek2: 5853,
    leanSummerMethodWeek3: 5898,
    leanSummerMethodWeek4: 5903,
    leanSummerMethodWeek5: 5931,
    leanSummerMethodWeek6: 5936,
    leanSummerMethodWeek7: 5941,
    leanSummerMethodWeek8: 5946,
    leanSecondBirthdayBash: 6049,
    twentyOneVol3: 6158,
    twentyOneVol3Week1: 6102,
    twentyOneVol3Week2: 6139,
    twentyOneVol3Week3: 6147,
    fatBurnCoreGalore: 6178,
    fatBurnCoreGaloreWeek1: 6274,
    yourStrongestSelf: 6293,
    shapeBurnPilates: 6302,
    shredWithWeights: 6340,
    hourGlassShredShape: 6357,
    absAndUpperBody: 6366,
    leanEmpoweredMethodPhase1: 6377,
    leanEmpoweredMethodPhase1Week1: 6453,
    leanEmpoweredMethodWeek3: 6477,
    leanEmpoweredMethodPhase1Week2: 6472,
    leanEmpoweredMethodPhase1Week4: 6482,
    leanEmpoweredMethodPhase2Week5: 6583,
    leanEmpoweredMethodPhase2: 6614,
    leanEmpoweredMethodPhase2Week6: 6589,
    leanEmpoweredMethodPhase2Week7: 6601,
    halloLeanHellWeek: 6624,
    leanEmpoweredMethodPhase2Week8: 6609,
    pilatesBootcampChallengeWeek1: 6740,
    pilatesBootcampChallengeWeek2: 6745,
    pilatesBootcampChallenge: 6805,
    twentyFiveDaysOfLEANMass: 6832,
    twentyFiveDaysOfLEANMassWeek1: 6766,
    twentyFiveDaysOfLEANMassWeek2: 6785,
    twentyFiveDaysOfLEANMassWeek3: 6790,
    twentyFiveDaysOfLEANMassWeek4: 6795,
    setYourNewYearGoals: 6879,
    newYearPrep: 6884,
    pilatesEvolutionPhase1: 7121,
    pilatesEvolutionWeek1: 6921,
    pilatesEvolutionWeek2: 7026,
    pilatesEvolutionWeek3: 7126,
    pilatesEvolutionWeek4: 7148,
    pilatesEvolutionPhase2: 7210,
    pilatesEvolutionWeek5: 7169,
    pilatesEvolutionWeek6: 7186,
    pilatesEvolutionWeek7: 7191,
    pilatesEvolutionDay50: 7199,
    pilatesEvolutionWeek9: 7204,
    bestOfLmpe: 7275,
    bestOfLmpeWeek1: 7238,
    bestOfLmpeWeek2: 7243,
    weekOfWellness: 7269,
    matInspiredReformerPilates: 7289,
    ultimateStrengthChallenge: 7301,
    pilatesStrengthFusion: 7348,
    lowImpactFatBurn: 7428,
    sunsOutBunsOut: 7438,
    powerUpPilatesWeek1: 7443,
    powerUpPilatesWeek2: 7472,
    powerUpPilatesWeek3: 7516,
    summerSurprisePrep: 7535,
    summerSurprisePrepw1: 7493,
    summerSurprisePrepw2: 7498,
    pilatesSummerSculptPhase1: 7551,
    pilatesSummerSculptWeek1: 7529,
    pilatesSummerSculptWeek2: 7567,
    pilatesSummerSculptWeek3: 7599,
    pilatesSummerSculptWeek4: 7632,
    pilatesSummerSculptPhase2: 7646,
    pilatesSummerSculptWeek5: 7638,
    pilatesSummerSculptWeek6: 7669,
    pilatesSummerSculptWeek7: 7687,
    pilatesSummerSculptWeek8: 7680,
    pilatesSummerSculptWeek9: 7728,
    leanLifestyle: 7737,
    coreStrengthStability: 7767,
    buildStrengthMonthWeek1: 7790,
    buildStrengthMonthWeek2: 7844,
    buildStrengthMonthWeek3: 7849,
    buildStrengthMonthWeek4: 7875,
    resetAndThriveChallenge: 7897,
    buildYourStengthMonth: 7920,
    bestOfLeanMethod: 7908,
    bestOfLeanMethodWeek1: 7913,
    bestOfLeanMethodWeek2: 7934,
    bestOfLeanMethodWeek3: 7939,
    bestOfLeanMethodWeek4: 7944,
    ultimateStrengthChallenge2: 7999,
    halloLeanHellWeek24: 8018,
    twentyOneVol4Week1: 8043,
    twentyOneVol4Week2: 8064,
    twentyOneVol4Week3: 8073,
    twentyOneVol4: 8103,
    bestOfSculptWeek1: 8036,
    bestOfSculptWeek2: 8113,
    bestOfSculptWeek3: 8121,
    bestOfSculptWeek4: 8175,
    bestOfSculptStrength: 8192,
    winterGlowUp2: 8208,
    newYearGoals: 8228,
    levelUpPrep: 8278,
    leanMethodLevelUp: 8296,
    leanMethodLevelUpW1: 8314,
    leanMethodLevelUpW2: 8349,
    leanMethodLevelUpW3: 8354,
    leanMethodLevelUpW4: 8369,
    leanMethodLevelUpW5: 8374,
    leanMethodLevelUpW6: 8433,
    leanMethodLevelUpW7: 8600,
    leanMethodLevelUpW8: 8606,
    leanMethodLevelUpW9: 8629,
    leanMethodDeloadWeek: 8652,
    toneAndTransform: 8744,
    coreStrengthStability2: 8749,
    sevenDayBootySculpt: 8788,
    defineAndRefine: 8793,
    sweatyBootcamp: 8905,
    summerPrep2025W1: 8956,
    summerPrep2025: 8950,
    summerPrep2025W2: 8972,
    leanMethodElevateW1: 8998,
    leanMethodElevateP1: 8981,    
    leamMethodLevel5: 9014,    
    leanMethodLevel4: 9019,    
    leanMethodLevel3: 9029,    
    leanMethodLevel2: 9024,
    leanMethodElevateW2: 9004,
    leanMethodElevateW3: 9009,
    leanMethodElevateW4: 9080,
    leanMethodElevateW5: 9092,
    leanMethodElevateP2: 8987,
    leanMethodElevateW6: 9139,
    leanMethodElevateW7: 9172,
    leanMethodElevateW8: 9179,
    leanMethodElevateW9: 9184,
    pilatesLowImpactWeek: 9198,
    scultLeanMuscle: 9204,
    buildStrengthPilates: 9210,
    leanAbsAndUpperBody: 9261,
    weightsAndBurn: 9266,
    resetChallenge: 9338,
    resetChallengeWeek1: 9321,
    resetChallengeWeek2: 9326,
    resetChallengeWeek3: 9331,
    powerLegsAndSculpt: 9356,
    wellnessReadyWeek: 9376,
    pilatedFusionBurn: 9361,
    leanSculptAndFlow: 9418,
    strengthAndBalance: 9451,
    transformationPrep: 9530,
    leanMethodTransformation: 9480,
    leanMethodTransformationW1: 9475,
    leanMethodTransformationW2: 9511,
    leanMethodTransformationW3: 9516,
    leanMethodTransformationW4: 9521,
    hourglassSculpt: 9586,
    lowerBodyStrengthSculpt: 9634,
    reformerInspiredPilates: 9644,
    coreCardioStength: 9659,
    defineChallengePhase: 9685,
    defineChallengeWeek1: 9665,
    defineChallengeWeek2: 9670,
    defineChallengeWeek3: 9675,
    defineChallengeWeek4: 9680,
    defineChallengePhase2: 9838,
    defineChallengeWeek5: 9846,
    leanDefineChallengeWeek6: 9851,
    leanDefineChallengeWeek7: 9858,
    leanDefineChallengeWeek8: 9861,
    lean2in1PrepWeek: 9907,
    lean2In1MethodPilatesXStrengthWeek1: 9920,
    lean2In1MethodPilatesXStrengthFullGuide: 9911,
    lean2In1MethodPilatesXStrengthWeek2: 9925,
    lean2In1MethodPilatesXStrengthWeek3: 9930,
    lean7DayBootySculpt2026: 9975,
    leanCoreStrengthAndStability: 9997,
    leanUltimateStrengthWeek: 10016,
    leanAbsAndUpperBody2026: 10024,
    leanSummerSculptChallengePrepWeek: 10046,
    leanSummerSculptChallengeFullGuide: 10051,
    leanSummerSculptChallengeWeek1: 10056,
    leanSummerSculptChallengeWeek2: 10079,
    leanSummerSculptChallengeWeek3: 10083,
    leanSummerSculptChallengeWeek4: 10140,
    leanSummerSculptChallengeWeek5: 10145,
    leanSummerSculptChallengeWeek6: 10150,
    leanLowerBodyStrengthandCardioWeek: 10187,
    lean2In1AbsAndSculptFullGuide: 10208,
    lean2In1AbsAndSculptWeek1: 10212,
    lean2in1AbsAndSculptFullLengthGuide: 10208,
    lean2In1AbsAndSculptWeekOne: 10216,
    lean2In1AbsAndSculptWeek2: 10220,
    lean2In1AbsandSculptWeek3: 10250,
    leanSummerSeriesArms: 10270,
    leanSummerSeriesLowerBody: 10287,
    leanSummerSeriesQuickBurn: 10292,
    leanSummerSeriesAbs: 10297,
    leanSummerSeriesGlutes2: 10312,
    summerSeriesUpperBody: 10317,
    leanChallengePrepWeekGuide: 10355,
    reDefineBeginner: 10370,
    redefineIntermediateandAdvanced: 10350,
    redefineIntermediateandAdvancedFullLength: 10366,
    redefineIntermediateWeek2: 10381,
    redefineWeek3: 10386,
    redefineWeek4: 10399,
  },
  7: {
    twentyOne: 3469,
    halloLean: 3484,
    cutGuide: 3667,
    leanMas: 4115,
    janWeek3: 4200,
    week4: 4233,
    week5: 4256,
    week6: 4263,
    leanAndStrongTransformationVol14Weeks: 4535,
    galentine: 4269,
    turnItUp: 4276,
    transformationV2: 4303,
    transformationV2_week2: 4309,
    transformationV2Week3: 4320,
    transformationV2Week4: 4352,
    transformationV2Week5: 4363,
    transformationV2Week6: 4416,
    leanAndStrongTransformationVol24Weeks: 4540,
    // maryBraunWeek1: 4453,
    // maryBraunWeek2: 4470,
    deloadPilatesBootCamp: 4444,
    preSummerBootcamp: 4465,
    // maryBraunWeek3: 4521,
    // maryBraunWeek4: 4526,
    feelGoodSummerWeek1: 4546,
    feelGoodSummerWeek2: 4556,
    feelGoodSummerWeek3: 4571,
    periodFriendly: 4570,
    feelGoodSummerWeek4: 4589,
    feelGoodSummerWeek5:4598,
    feelGoodSummerWeek6:4610,
    feelGoodSummer4Weeks: 4677,
    bestOfSculpt: 4648,
    bestOfShred: 4662,
    birthday:4699,
    vacay: 4704,
    vacayWeek2: 4726,
    vacayGuide4Weeks: 4846,
    glowWeek1:4747,
    glowWeek2:4753,
    glowWeek3:4789,
    glowWeek4:4794,
    greensAndGlow4Weeks: 4880,
    twentyOneVol2Week1: 4811,
    twentyOneVol2Week2: 4867,
    twentyOneVol2Week3: 4899,
    twentyOneVol24Weeks: 4991,
    gimmeGummyMore: 4920,
    septChallengeWeek1:4930,
    septChallengeWeek2:4939,
    feelGoodFitFactoryWeek3: 5016,
    feelGoodFitFactoryWeek4: 5058,
    feelGoodFitFactoryWeek5: 5080,
    feelGoodFitFactoryWeek6: 5094,
    feelGoodFitFactory4Weeks: 5137,
    halloLeanPrep: 5126,
    halloLeanHellWeek22: 5135,
    bestOfStrength: 5160,
    pilatesBody: 5195,
    busyGirlBlackFridayWeek1: 5233,
    busyGirlBlackFridayWeek2: 5250,
    busyGirlBlackFriday4Weeks: 5341,
    cardioGlowUp: 5280,
    cardioGlowUp4Weeks: 5342,
    leanAndPowerful: 5289,
    leanMass2022: 5309,
    leanMass2022Week2: 5336,
    leanMass2022Repacked: 5474,
    bestOfSculptMonth: 5354,
    leanTransformationMethodPhase1: 5513,
    leanTransformationMethodPhase2: 5608,
    leanTransformationMethodWeek1: 5363,
    leanTransformationMethodWeek2: 5457,
    leanTransformationMethodWeek3: 5462,
    leanTransformationMethodWeek4: 5467,
    leanTransformationMethodWeek5: 5535,
    leanTransformationMethodWeek6: 5540,
    leanTransformationMethodWeek7: 5545,
    leanTransformationMethodWeek8: 5550,
    recoverAndStrengthenPilates: 5629,
    winterGlowUp: 5681,
    lowerBody: 5694,
    upperBodyAndAbsShred: 5713,
    sculptBurnAndShape: 5739,
    ohhiit:5766,
    hourglassSculptAndStrengthen: 5784,
    ultimateWeekOfBattles: 5811,
    powerPilates: 5819,
    leanSummerMethodPhase1: 5885,
    leanSummerMethodPhase2: 5985,
    leanSummerMethodWeek1: 5835,
    leanSummerMethodWeek2: 5854,
    leanSummerMethodWeek3: 5897,
    leanSummerMethodWeek4: 5902,
    leanSummerMethodWeek5: 5930,
    leanSummerMethodWeek6: 5935,
    leanSummerMethodWeek7: 5940,
    leanSummerMethodWeek8: 5945,
    leanSecondBirthdayBash: 6044,
    twentyOneVol3: 6157,
    twentyOneVol3Week1: 6103,
    twentyOneVol3Week2: 6140,
    twentyOneVol3Week3: 6146,
    fatBurnCoreGalore: 6177,
    fatBurnCoreGaloreWeek1: 6273,
    yourStrongestSelf: 6292,
    shapeBurnPilates: 6301,
    shredWithWeights: 6341,
    hourGlassShredShape: 6358,
    absAndUpperBody: 6367,
    leanEmpoweredMethodPhase1: 6368,
    leanEmpoweredMethodPhase1Week1: 6454,
    leanEmpoweredMethodWeek3: 6478,
    leanEmpoweredMethodPhase1Week2: 6473,
    leanEmpoweredMethodPhase1Week4: 6483,
    leanEmpoweredMethodPhase2Week5: 6584,
    leanEmpoweredMethodPhase2: 6613,
    leanEmpoweredMethodPhase2Week6: 6588,
    leanEmpoweredMethodPhase2Week7: 6600,
    halloLeanHellWeek: 6623,
    leanEmpoweredMethodPhase2Week8: 6605,
    pilatesBootcampChallengeWeek1: 6739,
    pilatesBootcampChallengeWeek2: 6744,
    pilatesBootcampChallenge: 6804,
    twentyFiveDaysOfLEANMass: 6831,
    twentyFiveDaysOfLEANMassWeek1: 6767,
    twentyFiveDaysOfLEANMassWeek2: 6786,
    twentyFiveDaysOfLEANMassWeek3: 6791,
    twentyFiveDaysOfLEANMassWeek4: 6796,
    setYourNewYearGoals: 6877,
    newYearPrep: 6883,
    pilatesEvolutionPhase1: 7120,
    pilatesEvolutionWeek1: 6920,
    pilatesEvolutionWeek2: 7014,
    pilatesEvolutionWeek3: 7125,
    pilatesEvolutionWeek4: 7147,
    pilatesEvolutionPhase2: 7209,
    pilatesEvolutionWeek5: 7168,
    pilatesEvolutionWeek6: 7185,
    pilatesEvolutionWeek7: 7190,
    pilatesEvolutionDay50: 7198,
    pilatesEvolutionWeek9: 7203,
    bestOfLmpe: 7274,
    bestOfLmpeWeek1: 7237,
    bestOfLmpeWeek2: 7242,
    weekOfWellness: 7268,
    matInspiredReformerPilates: 7279,
    ultimateStrengthChallenge: 7300,
    pilatesStrengthFusion: 7349,
    lowImpactFatBurn: 7427,
    sunsOutBunsOut: 7437,
    powerUpPilatesWeek1: 7442,
    powerUpPilatesWeek2: 7471,
    powerUpPilatesWeek3: 7515,
    summerSurprisePrep: 7534,
    summerSurprisePrepw1: 7492,
    summerSurprisePrepw2: 7497,
    pilatesSummerSculptPhase1: 7550,
    pilatesSummerSculptWeek1: 7528,
    pilatesSummerSculptWeek2: 7566,
    pilatesSummerSculptWeek3: 7598,
    pilatesSummerSculptWeek4: 7631,
    pilatesSummerSculptPhase2: 7645,
    pilatesSummerSculptWeek5: 7637,
    pilatesSummerSculptWeek6: 7668,
    pilatesSummerSculptWeek7: 7686,
    pilatesSummerSculptWeek8: 7679,
    pilatesSummerSculptWeek9: 7727,
    leanLifestyle: 7736,
    coreStrengthStability: 7766,
    buildStrengthMonthWeek1: 7789,
    buildStrengthMonthWeek2: 7843,
    buildStrengthMonthWeek3: 7848,
    buildStrengthMonthWeek4: 7876,
    resetAndThriveChallenge: 7898,
    buildYourStengthMonth: 7919,
    bestOfLeanMethod: 7902,
    bestOfLeanMethodWeek1: 7912,
    bestOfLeanMethodWeek2: 7933,
    bestOfLeanMethodWeek3: 7938,
    bestOfLeanMethodWeek4: 7943,
    ultimateStrengthChallenge2: 7998,
    halloLeanHellWeek24: 8019,
    twentyOneVol4Week1: 8044,
    twentyOneVol4Week2: 8065,
    twentyOneVol4Week3: 8074,
    twentyOneVol4: 8104,
    bestOfSculptWeek1: 8035,
    bestOfSculptWeek2: 8114,
    bestOfSculptWeek3: 8120,
    bestOfSculptWeek4: 8174,
    bestOfSculptStrength: 8193,
    winterGlowUp2: 8209,
    newYearGoals: 8227,
    levelUpPrep: 8277,
    leanMethodLevelUp: 8292,
    leanMethodLevelUpW1: 8307,
    leanMethodLevelUpW2: 8348,
    leanMethodLevelUpW3: 8353,
    leanMethodLevelUpW4: 8370,
    leanMethodLevelUpW5: 8373,
    leanMethodLevelUpW6: 8432,
    leanMethodLevelUpW7: 8599,
    leanMethodLevelUpW8: 8605,
    leanMethodLevelUpW9: 8628,
    leanMethodDeloadWeek: 8651,
    toneAndTransform: 8745,
    coreStrengthStability2: 8750,
    sevenDayBootySculpt: 8787,
    defineAndRefine: 8792,
    sweatyBootcamp: 8904,
    summerPrep2025W1: 8955,
    summerPrep2025: 8949,
    summerPrep2025W2: 8971,
    leanMethodElevateW1: 8997,
    leanMethodElevateP1: 8982,    
    leamMethodLevel5: 9034,    
    leanMethodLevel4: 9035,    
    leanMethodLevel3: 9028,    
    leanMethodLevel2: 9023,
    leanMethodElevateW2: 9003,
    leanMethodElevateW3: 9008,
    leanMethodElevateW4: 9079,
    leanMethodElevateW5: 9091,
    leanMethodElevateP2: 8986,
    leanMethodElevateW6: 9138,
    leanMethodElevateW7: 9171,
    leanMethodElevateW8: 9178,
    leanMethodElevateW9: 9183,
    pilatesLowImpactWeek: 9197,
    scultLeanMuscle: 9202,
    buildStrengthPilates: 9209,
    leanAbsAndUpperBody: 9260,
    weightsAndBurn: 9265,
    resetChallenge: 9307,
    resetChallengeWeek1: 9317,
    resetChallengeWeek2: 9325,
    resetChallengeWeek3: 9330,
    powerLegsAndSculpt: 9350,
    wellnessReadyWeek: 9375,
    pilatedFusionBurn: 9360,
    leanSculptAndFlow: 9417,
    strengthAndBalance: 9450,
    transformationPrep: 9462,
    leanMethodTransformation: 9479,
    leanMethodTransformationW1: 9474,
    leanMethodTransformationW2: 9510,
    leanMethodTransformationW3: 9515,
    leanMethodTransformationW4: 9520,
    hourglassSculpt: 9585,
    lowerBodyStrengthSculpt: 9633,
    reformerInspiredPilates: 9650,
    coreCardioStength: 9654,
    defineChallengePhase: 9684,
    defineChallengeWeek1: 9664,
    defineChallengeWeek2: 9669,
    defineChallengeWeek3: 9674,
    defineChallengeWeek4: 9679,
    defineChallengePhase2: 9821,
    defineChallengeWeek5: 9845,
    leanDefineChallengeWeek6: 9850,
    leanDefineChallengeWeek7: 9859,
    leanDefineChallengeWeek8: 9860,
    lean2in1PrepWeek: 9906,
    lean2In1MethodPilatesXStrengthWeek1: 9919,
    lean2In1MethodPilatesXStrengthFullGuide: 9905,
    lean2In1MethodPilatesXStrengthWeek2: 9924,
    lean2In1MethodPilatesXStrengthWeek3: 9929,
    lean7DayBootySculpt2026: 9974,
    leanCoreStrengthAndStability: 9996,
    leanUltimateStrengthWeek: 10015,
    leanAbsAndUpperBody2026: 10021,
    leanSummerSculptChallengePrepWeek: 10045,
    leanSummerSculptChallengeFullGuide: 10050,
    leanSummerSculptChallengeWeek1: 10055,
    leanSummerSculptChallengeWeek2: 10069,
    leanSummerSculptChallengeWeek3: 10070,
    leanSummerSculptChallengeWeek4: 10139,
    leanSummerSculptChallengeWeek5: 10144,
    leanSummerSculptChallengeWeek6: 10149,
    leanLowerBodyStrengthandCardioWeek: 10181,
    lean2In1AbsAndSculptFullGuide: 10191,
    lean2In1AbsAndSculptWeek1: 10192,
    lean2in1AbsAndSculptFullLengthGuide: 10191,
    lean2In1AbsAndSculptWeekOne: 10193,
    lean2In1AbsAndSculptWeek2: 10194,
    lean2In1AbsandSculptWeek3: 10249,
    leanSummerSeriesArms: 10269,
    leanSummerSeriesLowerBody: 10286,
    leanSummerSeriesQuickBurn: 10291,
    leanSummerSeriesAbs: 10296,
    leanSummerSeriesGlutes2: 10311,
    summerSeriesUpperBody: 10316,
    leanChallengePrepWeekGuide: 10354,
    reDefineBeginner: 10335,
    redefineIntermediateandAdvanced: 10349,
    redefineIntermediateandAdvancedFullLength: 10334,
    redefineIntermediateWeek2: 10380,
    redefineWeek3: 10385,
    redefineWeek4: 10398,
  },
};

export const GUIDE_FIND_WORKOUT_FREQUENCY = (productID) =>
  Object?.keys(GUIDE_MAP)?.find((key) => Object?.values(GUIDE_MAP?.[key])?.indexOf(productID) > -1);

export const GUIDES_ORDER = [];
// [
//     GUIDE_MAP?.['3']?.smallerWaistGuide,
//     GUIDE_MAP?.['4']?.smallerWaistGuide,
//     GUIDE_MAP?.['5']?.smallerWaistGuide,
//     GUIDE_MAP?.['6']?.smallerWaistGuide,
//     GUIDE_MAP?.['3']?.booty,
//     GUIDE_MAP?.['4']?.booty,
//     GUIDE_MAP?.['5']?.booty,
//     GUIDE_MAP?.['6']?.booty,
//     GUIDE_MAP?.['3']?.hourglass,
//     GUIDE_MAP?.['4']?.hourglass,
//     GUIDE_MAP?.['5']?.hourglass,
//     GUIDE_MAP?.['6']?.hourglass,
// ];

// export const staging = {
//   aws: {
//     url: "https://rm56uphfwjfrnfe2msn3a6g6bi.appsync-api.eu-west-1.amazonaws.com/graphql",
//     region: "eu-west-1",
//     type: "AWS_IAM",
//   },
//   cognito: {
//     identityPoolId: "eu-west-1:4936b8f4-66cd-4175-84e5-7a983eb47180",
//     region: "eu-west-1",
//     userPoolId: "eu-west-1_3sxDScGLH",
//     userPoolWebClientId: "4jgkebm1mh2v2r8vq05f4q21b3",
//     mandatorySignIn: "false",
//   },
//   forgotPassword: "https://jhhs6d8jmb.execute-api.eu-west-1.amazonaws.com/dev",
//   verificationsBaseURL: "https://verifications.staging.genflow.com",
// };
export const staging = {
  aws: {
    url: "https://uyuh4pjnwnd3fdltnovspiihwu.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    type: "AWS_IAM",
  },
  cognito: {
    identityPoolId: "eu-west-1:8429ef9e-4f57-45f6-8354-4ec9b80a5fb9",
    region: "eu-west-1",
    userPoolId: "eu-west-1_lVdmqTrRz",
    userPoolWebClientId: "52veqmv4vo352fqmsevpr7vjk3",
    mandatorySignIn: "false",
  },
  forgotPassword: "https://7efpy5nte8.execute-api.eu-west-1.amazonaws.com/prod",
  verificationsBaseURL: "https://verifications.aws.genflow.com",
};
export const production = {
  aws: {
    url: "https://uyuh4pjnwnd3fdltnovspiihwu.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    type: "AWS_IAM",
  },
  cognito: {
    identityPoolId: "eu-west-1:8429ef9e-4f57-45f6-8354-4ec9b80a5fb9",
    region: "eu-west-1",
    userPoolId: "eu-west-1_lVdmqTrRz",
    userPoolWebClientId: "52veqmv4vo352fqmsevpr7vjk3",
    mandatorySignIn: "false",
  },
  forgotPassword: "https://7efpy5nte8.execute-api.eu-west-1.amazonaws.com/prod",
  verificationsBaseURL: "https://verifications.aws.genflow.com",
};

export const subscription = {
  rules: SUBSCRIPTION_RULES,
  hasSubscription: useHasSubscription,
};

export default {
  ...env,
  production,
  staging,
  subscription,
  GUIDE_MAP,
  GUIDES_ORDER,
  PHYSIO_COURSE_PRODUCT_ID,
  LEARN_EXERCISES_COURSE_PRODUCT_ID,
  NUTRITION_COURSE_PRODUCT_ID,
  FREE_BANDS_EDUCATION_COURSE_PRODUCT_ID,
};
